<template>
  <b-row
    :class="customChange ? 'list-group-item' : ''"
  >
    <b-col
      sm="12"
      md="12"
      lg="12"
    >
      <b-overlay
        id="overlay-background-documents"
        :show="documentLoader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-card>
          <b-card-header
            class="base-document-header"
          >
            <b-card-title>{{ $t('DEBTIA_DOCUMENTS') }}</b-card-title>
          </b-card-header>
          <b-card-header
            class="base-document-header"
          >
            <b-button-group
              size="sm"
            >
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                :class="baseDocumentType === 1 ? 'base-document-active-btn' : ''"
                @click="baseDocumentType = 1"
              >
                {{ $t('DEBTIA_ALL') }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                :class="baseDocumentType === 2 ? 'base-document-active-btn' : ''"
                @click="baseDocumentType = 2"
              >
                {{ $t('DEBTIA_UPLOADED') }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                :class="baseDocumentType === 3 ? 'base-document-active-btn' : ''"
                @click="baseDocumentType = 3"
              >
                {{ $t('DEBTIA_PROCESSED') }}
              </b-button>
            </b-button-group>
          </b-card-header>
          <!-- client documents starts -->
          <div
            class="scroll-div-documents"
          >
            <b-table
              ref="roles"
              :fields="documentsTableFields"
              :items="allBaseDocuments"
              striped
              show-empty
            >
              <template #empty="">
                <p>{{ $t('DEBTIA_NO_RECORD_FOUND') }}</p>
              </template>
              <template #cell(category)="data">
                {{ data.item.category ? data.item.category : data.item.template_name }}
              </template>
              <template #cell(file_link)="data">
                <feather-icon
                  icon="ExternalLinkIcon"
                  size="lg"
                  class="icon-styling"
                  @click="openLink(data.item.file_link)"
                />
              </template>
              <template #cell(interest_rate_percentage)="data">
                <div v-if="data.item.category == 'base documents'">
                  {{ (data.item.interest_rate_agreed) ? data.item.interest_rate_percentage + '%' : data.item.default_interest_rate + '% standard process rente' }}
                </div>
                <div v-else>
                  -
                </div>
              </template>
            </b-table>
          </div>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BCardHeader, BCardTitle, BTable, BButton, BButtonGroup, BOverlay,
} from 'bootstrap-vue'
// import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import constants from '@/app-configs/constants'
import axios from '@axios'
import i18n from '@/libs/i18n'
// import DragLinks from '../DragLinks.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTable,
    BCardHeader,
    BCardTitle,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    // DragLinks,
    BButton,
    BButtonGroup,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    customChange: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      documentLoader: false,
      header_check: false,
      baseDocumentType: 1,
      allBaseDocuments: [],
      processedLetters: [],
      baseDocumentVariables: {},
      selectedBaseDocuments: [],
      selectedDeletableDocuments: [],
      baseDocumentsCategories: [],
      baseDocumentTemplates: [],
      creditNotes: [],
      debtReminders: [],
      otherFiles: [],
      letterFiles: [],
      documentsData: [],
      caseID: this.$route.params.id,
      allDocumentsData: [],
      constants,
      lltter: 0,
      checkAll: false,
    }
  },
  computed: {
    tableFields() {
      return [
        {
          key: 'category', sortable: true, label: i18n.t('DEBTIA_CATEGORY'), tdClass: 'text-capitalize',
        },
        { key: 'title', sortable: true, label: i18n.t('DEBTIA_TITLE') },
        { key: 'file_link', sortable: true, label: i18n.t('DEBTIA_FILE_LINK') },
        { key: 'payment_amount', sortable: true, label: i18n.t('DEBTIA_PAYMENT_AMOUNT') },
        { key: 'vat_amount', sortable: true, label: i18n.t('DEBTIA_VAT_AMOUNT') },
        { key: 'paid_amount', sortable: true, label: i18n.t('DEBTIA_PAID_AMOUNT') },
        { key: 'interest_rate_percentage', sortable: true, label: i18n.t('DEBTIA_INTEREST_RATE') },
        { key: 'document_due_date', sortable: true, label: i18n.t('DEBTIA_DOCUMENT_DUE_DATE') },
        { key: 'document_send_date', sortable: true, label: i18n.t('DEBTIA_DOCUMENT_SENT_DATE') },
      ]
    },
    documentsTableFields() {
      return [
        {
          key: 'category', sortable: true, label: i18n.t('DEBTIA_CATEGORY_TEMPLATE'), tdClass: 'text-capitalize',
        },
        { key: 'title', sortable: true, label: i18n.t('DEBTIA_TITLE') },
        { key: 'file_link', sortable: true, label: i18n.t('DEBTIA_FILE_LINK') },
        { key: 'payment_amount', sortable: true, label: i18n.t('DEBTIA_PAYMENT_AMOUNT') },
        { key: 'vat_amount', sortable: true, label: i18n.t('DEBTIA_VAT_AMOUNT') },
        { key: 'paid_amount', sortable: true, label: i18n.t('DEBTIA_PAID_AMOUNT') },
        { key: 'interest_rate_percentage', sortable: true, label: i18n.t('DEBTIA_INTEREST_RATE') },
        { key: 'document_due_date', sortable: true, label: i18n.t('DEBTIA_DOCUMENT_DUE_DATE') },
        { key: 'document_send_date', sortable: true, label: i18n.t('DEBTIA_DOCUMENT_SENT_DATE') },
      ]
    },
    letterFilesCount() {
      // Access the letterFiles property from the store and compute its length
      return this.$store.state['case-details'].letterFiles.propertyA
    },
  },
  watch: {
    baseDocumentType: {
      handler() {
        this.documentLoader = true
        this.allBaseDocuments = []
        if (this.selectedBaseDocuments.length > 0) {
          this.selectedBaseDocuments.forEach(element => {
            this.baseDocumentVariables[`checkbox_${element}`].check = false
          })
        }
        setTimeout(() => {
          this.getCurrentBaseDocuments(this.baseDocumentType)
          this.documentLoader = false
        }, 500)
      },
    },
    header_check: {
      handler() {
        this.baseDocumentsCategories = []
        this.baseDocumentTemplates = []
        this.selectedBaseDocuments = []
        this.selectedDeletableDocuments = []
        Object.keys(this.baseDocumentVariables).forEach(element => {
          this.baseDocumentVariables[element].check = this.header_check
          this.categoryCheck(this.header_check, this.baseDocumentVariables[element].id, this.baseDocumentVariables[element].category, this.baseDocumentVariables[element].template_id, this.baseDocumentVariables[element].template_name, this.baseDocumentVariables[element].debt_stage)
          if (this.header_check) {
            this.selectedBaseDocuments.push(this.baseDocumentVariables[element].id)
            if (this.baseDocumentVariables[element].debt_stage === 'other_files') {
              this.selectedDeletableDocuments.push(this.baseDocumentVariables[element].id)
            }
          }
        })
      },
    },
  },
  created() {
    this.getDocuments()
  },
  methods: {
    async getDocuments() {
      this.documentLoader = true
      const url = `/debt-case/docs/${this.caseID}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.baseDocuments = response.data.data.base_documents
          this.creditNotes = response.data.data.credit_notes
          this.debtReminders = response.data.data.debt_reminders
          this.otherFiles = response.data.data.other_files
          this.letterFiles = response.data.data.letter_files
          this.addProcessedLettersForBaseDocuments(this.letterFiles)
          this.getCurrentBaseDocuments(1)
          this.documentLoader = false
        }
      })
    },
    getCurrentBaseDocuments(type) {
      this.header_check = false
      if (type === 2) {
        this.allBaseDocuments = [...this.baseDocuments, ...this.creditNotes, ...this.debtReminders, ...this.otherFiles]
      } else if (type === 3) {
        this.allBaseDocuments = [...this.processedLetters]
      } else {
        this.allBaseDocuments = [...this.baseDocuments, ...this.creditNotes, ...this.debtReminders, ...this.otherFiles, ...this.processedLetters]
      }
      this.makeVariableForBaseDocuments(this.allBaseDocuments)
    },
    addProcessedLettersForBaseDocuments(letters) {
      this.processedLetters = []
      letters.forEach(element => {
        const obj = {
          id: element.id,
          category: null,
          category_id: null,
          debt_stage: 'letter_files',
          title: element.file_name,
          file_link: element.file_link,
          default_interest_rate: '',
          document_due_date: '',
          document_send_date: '',
          interest_rate_agreed: '',
          interest_rate_percentage: '',
          paid_amount: '',
          payment_amount: '',
          rest_amount: '',
          total_amount: '',
          vat_amount: '',
          template_name: element.title,
          template_id: element.letter_template_id,
        }
        this.processedLetters.push(obj)
      })
    },
    makeVariableForBaseDocuments(documents) {
      this.baseDocumentVariables = {}
      this.selectedBaseDocuments = []
      this.selectedDeletableDocuments = []
      documents.forEach(element => {
        this.baseDocumentVariables[`checkbox_${element.id}`] = {
          id: element.id,
          check: false,
          category: element.category ? this.capitalizeWords(element.category) : null,
          category_id: element.category_id,
          debt_stage: element.debt_stage,
          title: element.title,
          template_name: element.template_name,
          template_id: element.template_id,
        }
      })
    },
    async openLink(href) {
      window.open(href, '_blank')
    },
    baseDocumentCheckBoxClicked(value, id) {
      if (value) {
        this.selectedBaseDocuments.push(id)
        if (this.baseDocumentVariables[`checkbox_${id}`].debt_stage === 'other_files') {
          this.selectedDeletableDocuments.push(id)
        }
      } else {
        // to remove the checkbox id
        const indexToRemove = this.selectedBaseDocuments.indexOf(id)
        if (indexToRemove !== -1) {
          this.selectedBaseDocuments.splice(indexToRemove, 1)
        }
        const deleteIndexToRemove = this.selectedDeletableDocuments.indexOf(id)
        if (deleteIndexToRemove !== -1) {
          this.selectedDeletableDocuments.splice(deleteIndexToRemove, 1)
        }
      }
    },
    capitalizeWords(str) {
      return str.replace(/\b\w/g, char => char.toUpperCase())
    },
    confirmDeleteDocument(id, title, fileLink) {
      this.$swal({
        title: i18n.t('DEBTIA_SURE'),
        text: `${i18n.t('DEBTIA_DELETING_FILE_TEXT')} ${title}. ${i18n.t('DEBTIA_REVERT_MSG')}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          const obj = {
            debt_case_id: this.caseID,
            files_data: [
              {
                debt_stage: 'letter_files',
                link: fileLink,
              },
            ],
            ids: [id],
          }
          axios.post('/delete-debt-case-file', obj).then(response => {
            if (response.status === 200) {
              if (response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Deleted!',
                  text: '',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                this.getDocuments()
              }
            }
          })
        }
      })
    },
    downloadAllFiles() {
      this.baseDocumentsCategories = []
      this.baseDocumentTemplates = []
      Object.keys(this.baseDocumentVariables).forEach(element => {
        this.categoryCheck(true, this.baseDocumentVariables[element].category_id, this.baseDocumentVariables[element].category, this.baseDocumentVariables[element].template_id, this.baseDocumentVariables[element].template_name, this.baseDocumentVariables[element].debt_stage)
      })
    },
    downloadSelectedFiles() {
      this.baseDocumentsCategories = []
      this.baseDocumentTemplates = []
      this.selectedBaseDocuments.forEach(element => {
        this.categoryCheck(true, this.baseDocumentVariables[`checkbox_${element}`].category_id, this.baseDocumentVariables[`checkbox_${element}`].category, this.baseDocumentVariables[`checkbox_${element}`].template_id, this.baseDocumentVariables[`checkbox_${element}`].template_name, this.baseDocumentVariables[`checkbox_${element}`].debt_stage)
      })
    },
    categoryCheck(check, categoryId, categoryName, templateId, templateName, debtStage) {
      if (categoryName === 'Base Documents' || categoryName === 'Credit Notes' || categoryName === 'Debt Reminders' || categoryName === 'Processed Letters') {
        const foundCategory = this.baseDocumentsCategories.findIndex(item => item.id === categoryId && item.name === categoryName)
        const obj = {
          id: categoryId,
          name: categoryName,
          debt_stage: debtStage,
        }
        if (check && foundCategory === -1) {
          this.baseDocumentsCategories.push(obj)
        }
        // to remove the checkbox category
        if (!check && foundCategory !== -1) {
          this.baseDocumentsCategories.splice(foundCategory, 1)
        }
      }
      if (categoryId) {
        const foundCategory = this.baseDocumentsCategories.findIndex(item => item.id === categoryId)
        const obj = {
          id: categoryId,
          name: categoryName,
          debt_stage: debtStage,
        }
        if (check && foundCategory === -1) {
          this.baseDocumentsCategories.push(obj)
        }
        // to remove the checkbox category
        if (!check && foundCategory !== -1) {
          this.baseDocumentsCategories.splice(foundCategory, 1)
        }
      }
      if (templateId) {
        const foundTemplate = this.baseDocumentTemplates.findIndex(item => item.id === templateId)
        // const categoryToRemove = this.baseDocumentsCategories.indexOf(this.capitalizeWords(category))
        const obj = {
          id: templateId,
          name: templateName,
          debt_stage: debtStage,
        }
        if (check && foundTemplate === -1) {
          this.baseDocumentTemplates.push(obj)
        }
        // to remove the checkbox category
        if (!check && foundTemplate !== -1) {
          this.baseDocumentTemplates.splice(foundTemplate, 1)
        }
      }
    },
    deleteConfirmationPopup() {
      let titles = ''
      this.selectedDeletableDocuments.forEach(element => {
        titles += `${this.baseDocumentVariables[`checkbox_${element}`].title}<br>`
      })
      this.$swal({
        title: i18n.t('DEBTIA_SURE'),
        text: i18n.t('DEBTIA_SURE_REVERT_MSG'),
        icon: 'warning',
        html:
          `${i18n.t('DEBTIA_FILE_DELETION_MSG')}: <br>${titles}${i18n.t('DEBTIA_SURE_REVERT_MSG')}`,
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES_DELETE_IT_1'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.deleteFiles()
        }
      })
    },
    async deleteFiles() {
      const filesData = []
      this.selectedBaseDocuments.forEach(element => {
        const filteredObj = this.allBaseDocuments.filter(documentelement => element === documentelement.id)
        filesData.push(filteredObj[0])
      })
      const obj = {
        debt_case_id: this.caseID,
        ids: this.selectedDeletableDocuments,
        files_data: filesData,
      }
      await axios.post('/delete-debt-case-file', obj).then(responseLocal => {
        if (responseLocal.status) {
          this.refreshCheckboxes()
          this.getDocuments()
          this.processedLetters = []
          this.$swal({
            icon: 'success',
            title: 'Deleted!',
            text: i18n.t('DEBTIA_FILE_DELETION_MSG'),
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      }).catch(err => {
        this.loader = false
        this.alertErrors = [...err.response.data.message]
      })
    },
    refreshCheckboxes() {
      // this.baseDocumentVariables.checkbox_5924.check = false
      if (this.header_check) {
        this.header_check = false
      } else if (this.selectedBaseDocuments.length > 0) {
        this.documentLoader = true
        this.allBaseDocuments = []
        setTimeout(() => {
          this.getCurrentBaseDocuments(this.baseDocumentType)
          this.documentLoader = false
        }, 500)
      }
      this.selectedBaseDocuments = []
      this.selectedDeletableDocuments = []
    },
  },
}
</script>

<style lang="scss">

.document-buttons {
    margin-right: 5px;
  }

  .padding-1 {
    padding: 1px !important;
  }

  .icon-styling {
    cursor: pointer;
  }
.scroll-div-documents {
  overflow-y: scroll;
  /* Ensure the inner div doesn't exceed the container */
  max-height: 350px;
  padding-right: 10px;
}

.scroll-div-documents::-webkit-scrollbar {
    width: 12px;
}

.scroll-div-documents::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
}

.scroll-div-documents::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}
</style>
